import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function BankIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9085 1.02329C12.3203 0.817433 11.6797 0.817434 11.0915 1.02329L3.09154 3.82329C1.98855 4.20933 1.25 5.2503 1.25 6.4189V7.99993C1.25 8.96643 2.0335 9.74994 3 9.74994H3.25V17.4183C2.65876 17.6992 2.25 18.3018 2.25 18.9999V19.2749C1.67944 19.3908 1.25 19.8952 1.25 20.4999V20.9999C1.25 21.9664 2.0335 22.7499 3 22.7499H21C21.9665 22.7499 22.75 21.9664 22.75 20.9999V20.4999C22.75 19.8952 22.3206 19.3908 21.75 19.2749V18.9999C21.75 18.3018 21.3412 17.6992 20.75 17.4183V9.74994H21C21.9665 9.74994 22.75 8.96643 22.75 7.99993V6.4189C22.75 5.2503 22.0115 4.20933 20.9085 3.82329L12.9085 1.02329ZM4.75 17.2499V9.74994H7.25V17.2499H4.75ZM8.75 17.2499V9.74994H11.25V17.2499H8.75ZM12.75 17.2499V9.74994H15.25V17.2499H12.75ZM16.75 17.2499V9.74994H19.25V17.2499H16.75ZM10.75 5.49993C10.75 4.80958 11.3096 4.24993 12 4.24993C12.6904 4.24993 13.25 4.80958 13.25 5.49993C13.25 6.19029 12.6904 6.74993 12 6.74993C11.3096 6.74993 10.75 6.19029 10.75 5.49993Z"
        fill="currentColor"
      />
    </svg>
  )
}
